import { render, staticRenderFns } from "./TheAsignar.vue?vue&type=template&id=63a3aca9&scoped=true&"
import script from "./TheAsignar.vue?vue&type=script&lang=js&"
export * from "./TheAsignar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3aca9",
  null
  
)

export default component.exports